import {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    object,
    moreNav,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
} from './ThirdMapping';

var entitiesTabs = [
    {
        label: Loc.g('Activité'),
        value: 'activity',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Éléments épinglés'),
        value: 'pinned',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Commentaires'),
        value: 'note',
        entities: ['annotation'],
        databot: 'inv-overview__activity--comment-list',
    },
    {
        label: Loc.g('Emails'),
        value: 'email',
        entities: ['email'],
        databot: 'inv-overview__activity--email-list',
    },
    {
        label: Loc.g('Tâches'),
        value: 'task',
        entities: ['task'],
        databot: 'inv-overview__activity--task-list',
    },
    {
        label: Loc.g('Evènements'),
        value: 'event',
        entities: ['event'],
        databot: 'inv-overview__activity--event-list',
    },
    {
        label: Loc.g('Appels'),
        value: 'phonecall',
        entities: ['phonecall'],
        databot: 'inv-overview__activity--call-list',
    },
    {
        label: Loc.g('Marketing'),
        value: 'marketing',
        entities: ['marketing'],
        databot: 'inv-overview__activity--marketing-list',
    },
];

var entitiesGroups = [
    {
        label: Loc.g('Activité'),
        value: 'clientActivity',
        entities: [
            'task',
            'event',
            'annotation',
            'email',
            'phonecall',
            'client',
            'timetracking',
            'ticket',
            'snippettracking',
            'marketing',
        ],
    },
    {
        label: Loc.g('Prospection'),
        value: 'prospection',
        entities: ['campaign', 'opportunity', 'estimate', 'propdocument'],
    },
    {
        type: 'component',
        component: 'timeline-author-filter',
        label: Loc.g('Collaborateurs'),
        value: 'authors',
        filter: true,
        entities: [],
        display: 'block',
    },
];

var defaultEntities = [
    'email',
    'phonecall',
    'client',
    'annotation',
    'event',
    'task',
    'timetracking',
    'ticket',
    'campaign',
    'opportunity',
    'estimate',
    'propdocument',
    'snippettracking',
    'marketing',
];

var forcedLabel = [
    {
        value: 'document',
        label: Loc.g('Mises à jour'),
    },
];

var availableStatCards = [
    'invoice_third',
    'estimate_third',
    'turnover_third',
    'top_selling_items_third',
    'sales_margin_third',
];

const databots = {
    activity: 'inv-overview__menu--activity',
    informations: 'inv-overview__menu--general-info',
    financialactivity: 'inv-overview__menu--financial-info',
    contacts: 'inv-overview__menu--contact-linked',
    addresses: 'inv-overview__menu--address',
    customfields: 'inv-overview__menu--cf',
    statistics: 'inv-overview__menu--stat',
    opportunity: 'inv-overview__menu--opportunity',
    estimate: 'inv-overview__menu--document',
    invoice: 'inv-overview__menu--document',
    delivery: 'inv-overview__menu--document',
    order: 'inv-overview__menu--document',
    creditnote: 'inv-overview__menu--document',
    proforma: 'inv-overview__menu--document',
    payments: 'inv-overview__menu--payment',
    bankaccount: 'inv-overview__menu--bank-account',
    recurring: 'inv-overview__menu--recurring',
    mandates: 'inv-overview__menu--mandate',
    timetracking: 'inv-overview__menu--timetracking',
    tickets: 'inv-overview__menu--ticket',
    project: 'inv-overview__menu--project',
    proposal: 'inv-overview__menu--proposal',
    emailingprofile: 'inv-overview__menu--mailing-list',
    massmailingMailinglist: 'inv-overview__menu--mailing-list',
    massmailingCampaignList: 'inv-overview__menu--mailing-list',
    receipts: 'inv-overview__menu--receipt',
    briefcase: 'inv-overview__menu--briefcase',
    activitycommentadd: 'inv-overview__activity--comment-add',
    emailadd: 'inv-overview__activity--email-add',
    calladd: 'inv-overview__activity--call-add',
    taskadd: 'inv-overview__activity--task-add',
    eventadd: 'inv-overview__activity--event-add',
    generalinfoedit1: 'inv-overview__section--general-info-edit-1',
    generalinfoedit2: 'inv-overview__section--general-info-edit-2',
    marketing: 'inv-overview__section--marketing',
};

export {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    entitiesTabs,
    defaultEntities,
    entitiesGroups,
    forcedLabel,
    object,
    moreNav,
    availableStatCards,
    databots,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
};
